"use client";

import { useRouter } from "next/navigation";
import { Button } from "@/components/kit";

const NotFoundActions = () => {
  const router = useRouter();
  return (
    <div className="mt-3 flex items-center gap-2">
      <Button variant="secondary" size="sm" onClick={() => router.back()}>
        이전으로
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={() => router.push("/places")}
      >
        장소 둘러보기
      </Button>
    </div>
  );
};

export default NotFoundActions;
